import React, { memo } from "react";

const Tooltip = memo((props) => {
  return (
    <span className="group relative">
      <span style={{bottom:"calc(100% + 8px)"}} className="pointer-events-none absolute left-1/2 -translate-x-1/2 rounded bg-black px-2 py-1 text-white opacity-0  before:absolute before:left-1/2 before:top-full before:-translate-x-1/2 before:border-4 before:border-transparent before:border-t-black before:content-[''] group-hover:opacity-100 transition-all duration-300 scale-75  group-hover:scale-100">
        {props.content}
      </span>
      {props.children}
    </span>
  );
});

Tooltip.displayName = "Tooltip";

export default Tooltip;
